import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/HomeIndex.vue')
  },
  {
    path: '/en/pricacyPolicy',
    name: 'enPricacyPolicy',
    component: () => import('@/views/agreement/en/PricacyPolicy.vue')
  },
  {
    path: '/en/serviceTerms',
    name: 'enServiceTerms',
    component: () => import('@/views/agreement/en/ServiceTerms.vue')
  },
  {
    path: '/en/notice',
    name: 'enNotice',
    component: () => import('@/views/agreement/en/NoticePage.vue')
  },
  {
    path: '/en/help',
    name: 'enHelp',
    component: () => import('@/views/agreement/en/AppraisalHelp.vue')
  },
  {
    path: '/zh/pricacyPolicy',
    name: 'zhPricacyPolicy',
    component: () => import('@/views/agreement/zh/PricacyPolicy.vue')
  },
  {
    path: '/zh/serviceTerms',
    name: 'zhServiceTerms',
    component: () => import('@/views/agreement/zh/ServiceTerms.vue')
  },

  {
    path: '/zh/notice',
    name: 'zhNotice',
    component: () => import('@/views/agreement/zh/NoticePage.vue')
  },
  {
    path: '/zh/help',
    name: 'zhHelp',
    component: () => import('@/views/agreement/zh/AppraisalHelp.vue')
  },
  {
    path: '/questionZh',
    name: 'questionZh',
    component: () => import('@/views/question/QuestionIndexZh.vue')
  },
  {
    path: '/questionEn',
    name: 'questionEn',
    component: () => import('@/views/question/QuestionIndexEn.vue')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/en/IndexView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
